import { CountPill } from "./CountPill";

export default CountPill;
